import Vue from "vue";
const templateId = +document.body.getAttribute("tplid") || document.body.getAttribute("data-tplid");
const templatePath = "./templates/" + templateId + "/doubleinput.js";

let component = Vue.component("doubleinput", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props:['opt','jsonval', 'urlValue'],
      data() {
        return {
          templateId:templateId,
          isLabel:false,
          minmod: '',
          maxmod: ''
        }
      },
      computed:{
        labelclasstrue(){ return this.templateId>35 ? 'ok-form-label -state-active' : 'col-md-12 ok-label-static'},
        labelclassfalse(){ return this.templateId>35 ? 'ok-form-label' : 'col-md-12 ok-label-static -state-empty'},
      },
      watch: {
        minmod() {
          if (this.minmod==='' && this.maxmod==='' || isNaN(this.minmod) && isNaN(this.maxmod) || isNaN(this.minmod) && this.maxmod==='' || isNaN(this.maxmod) && this.minmod==='') {
            this.isLabel=false;
          } else {
            this.isLabel=true;}
        },
        maxmod() {
          if (this.maxmod==='' && this.minmod==='' || isNaN(this.minmod) && isNaN(this.maxmod) || isNaN(this.minmod) && this.maxmod==='' || isNaN(this.maxmod) && this.minmod==='') {
            this.isLabel=false;
          } else {
            this.isLabel=true;}
        },
        'urlValue': function() {
          if (this.urlValue.indexOf('group_id=') > 0) {
            let text2_min = this.urlValue.substring(this.urlValue.indexOf('findtext='))
            let text_min = text2_min.substring(text2_min.indexOf(`min_${this.opt.name}`))
            let first_min = text2_min.substring(text2_min.indexOf(`min_${this.opt.name}`)).indexOf('=')
            let last_min = null
            if (text2_min.substring(text2_min.indexOf(`min_${this.opt.name}`)).indexOf('&') === -1) {
              last_min =  text2_min.substring(text2_min.indexOf(`min_${this.opt.name}`)).length
            } else {
              last_min = text2_min.substring(text2_min.indexOf(`min_${this.opt.name}`)).indexOf('&')
            }
            let res_min = parseInt(text_min.substring(first_min + 1, last_min))
            let text2_max = this.urlValue.substring(this.urlValue.indexOf('findtext='))
            let text_max = text2_max.substring(text2_max.indexOf(`max_${this.opt.name}`))
            let first_max = text2_max.substring(text2_max.indexOf(`max_${this.opt.name}`)).indexOf('=')
            let last_max = null
            if (text2_max.substring(text2_max.indexOf(`max_${this.opt.name}`)).indexOf('&') === -1) {
              last_max =  text2_max.substring(text2_max.indexOf(`max_${this.opt.name}`)).length
            } else {
              last_max = text2_max.substring(text2_max.indexOf(`max_${this.opt.name}`)).indexOf('&')
            }
            let res_max = parseInt(text_max.substring(first_max + 1, last_max))
            this.minmod = res_min
            this.maxmod = res_max
          }
        }
      }
    });
  });
});
export default component;



// WEBPACK FOOTER //
// ./src/components/doubleinput.js